import type { SurveyPage } from '../../fetchSurvey/types';
import type { LogicContext } from '../../surveyLogic/types';
import { getPreviousVisiblePageIndex } from '../../surveyLogic/navigation/getPreviousVisiblePageIndex';
import { shouldIncludePageInPath } from '../../surveyLogic/visibility';
import type { SurveyPaginationRefs } from '../types';
import { popPageHistory } from './pageHistory';

function trimPageHistoryTo(refs: SurveyPaginationRefs, targetPageIndex: number): void {
  const position = refs.pageHistory.lastIndexOf(targetPageIndex);
  if (position >= 0) {
    refs.pageHistory = refs.pageHistory.slice(0, position + 1);
    return;
  }

  refs.pageHistory = [targetPageIndex];
}

function resolveVisibleBackTarget(
  pages: SurveyPage[],
  startPageIndex: number,
  context: LogicContext
): number {
  let pageIndex = startPageIndex;

  while (pageIndex > 0) {
    const questions = pages[pageIndex]?.questions ?? [];
    if (shouldIncludePageInPath(questions, context)) {
      return pageIndex;
    }

    pageIndex = getPreviousVisiblePageIndex(pages, pageIndex, context);
  }

  return 0;
}

export function resolveBackTargetPageIndex(
  refs: SurveyPaginationRefs,
  pages: SurveyPage[],
  currentPageIndex: number,
  context: LogicContext
): number | null {
  if (refs.pageHistory.length > 1) {
    const poppedTarget = popPageHistory(refs);
    if (poppedTarget === null) {
      return null;
    }

    const visibleTarget = resolveVisibleBackTarget(pages, poppedTarget, context);
    trimPageHistoryTo(refs, visibleTarget);
    return visibleTarget;
  }

  if (currentPageIndex > 0) {
    const targetPageIndex = getPreviousVisiblePageIndex(pages, currentPageIndex, context);
    if (targetPageIndex >= currentPageIndex) {
      return null;
    }

    trimPageHistoryTo(refs, targetPageIndex);
    return targetPageIndex;
  }

  return null;
}
